import {
  AnalyticsEvent,
  EventType,
  LinkName,
  type Payload,
  type RoleRequirementsEvent,
  TrackingType,
  UnifiedAnalyticsEvent,
  type UnifiedPayload,
} from '../types';

import { spreadableTestingId } from './experiments';

interface QuestionsSearchedPayload
  extends Payload<TrackingType.Link, LinkName.QuestionsSearched> {}

interface UnifiedQuestionsSearchedPayload
  extends UnifiedPayload<UnifiedAnalyticsEvent.QuestionSearched> {}

const sendQuestionsSearchedEvent =
  (
    onEvent: (event: RoleRequirementsEvent) => void,
    unifiedAnalytics: boolean,
  ) =>
  (): void => {
    const analyticsPayload = unifiedAnalytics
      ? {
          eventName: UnifiedAnalyticsEvent.QuestionSearched as const,
          currentPageSection: 'role requirements' as const,
          ...spreadableTestingId(),
        }
      : ({
          trackingType: TrackingType.Link,
          linkName: LinkName.QuestionsSearched,
          eventName: [AnalyticsEvent.QuestionsSearched],
          ...spreadableTestingId(),
        } as QuestionsSearchedPayload);

    const spreadableName = unifiedAnalytics
      ? {}
      : {
          name: EventType.QuestionsSearched,
        };

    onEvent({
      data: [
        {
          payload: {
            analytics: analyticsPayload,
          },
          ...spreadableName,
        },
      ],
    });
  };

export {
  type QuestionsSearchedPayload,
  type UnifiedQuestionsSearchedPayload,
  sendQuestionsSearchedEvent,
};
